import { PromoPageContent } from 'components/common/PromoPageContent';
import { useLandingPage } from 'hooks/pages/useLandingPage';
import { useRouter } from 'next/router';

export const LandingPage = () => {
  const router = useRouter();
  const { slug } = router.query;
  const { data: landingPage } = useLandingPage(slug as string);

  return <PromoPageContent {...landingPage} noindex={false} />;
};
